import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer} from '@angular/platform-browser';
import {SecretaireService} from '../../../services/secretaire.service';

@Component({
  selector: 'app-pdf-depart',
  templateUrl: './pdf-depart.component.html',
  styleUrls: ['./pdf-depart.component.scss']
})
export class PdfDepartComponent implements OnInit {
  src: any ;
  cA: any ;

  constructor(
      public dialogRef: MatDialogRef<PdfDepartComponent> ,
      private sanitizer: DomSanitizer ,
      private secretaireService: SecretaireService ,
  ) {
    this.sanitizer = sanitizer ;
  }
  ngOnInit(): void {
    this.src = this.dialogRef.id ;
    this.getCourrier(this.src) ;
  }
  // tslint:disable-next-line:typedef
  getPdf(programme: any ){
    const byteArray = new Uint8Array(atob(programme).split('').map(char => char.charCodeAt(0)));
    const blob = new Blob([byteArray], {type: 'application/pdf'});
    if (blob){
      const url = window.URL.createObjectURL(blob);
      if (url !== null){
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    }
    return null;
  }
  // tslint:disable-next-line:typedef
  getCourrier(src: any) {
    this.secretaireService.getCourrierDepartPdf(src).subscribe(
        data => {console.log(data) ; this.cA = data.pieceJointe ;  console.log(this.cA);   }  );
  }
}
